import RestClient from './rest-client'

export default class Shipment extends RestClient {
  static get url () {
    return this.apiUrl + '/shipments'
  }

  static get paramKey () {
    return 'shipment'
  }

  static async export (params) {
    const { data } = await this.http({
      url: this.url + '/export',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }

  static async sync () {
    const { data } = await this._post(this.apiUrl + '/syncs')

    return data
  }

  async requestCancel () {
    const { data } = await this.constructor._put(this.constructor.url + '/' + this.id + '/request_cancellation')
    this._setAttributes(data.data)

    return data.data
  }

  async cancel () {
    const { data } = await this.constructor._put(this.constructor.url + '/' + this.id + '/cancel')
    this._setAttributes(data.data)

    return data.data
  }

  async deliver () {
    const { data } = await this.constructor._put(this.constructor.url + '/' + this.id + '/deliver')
    this._setAttributes(data.data)

    return data.data
  }

  async rejectCancelRequest () {
    const { data } = await this.constructor._put(this.constructor.url + '/' + this.id + '/reject_cancel_shipment')
    this._setAttributes(data.data)

    return data.data
  }

  async clone () {
    const { data } = await this.constructor._post(this.constructor.url + '/' + this.id + '/clone')
    return data.data
  }

  static async uploadLabel (formData) {
    const { data } = await this._post(this.url + '/upload_label', formData)
    return data
  }

  static async importCsvShipment (formData) {
    const { data } = await this._post(this.url + '/import_csv_shipments', formData)
    return data
  }

  static async exportCsv () {
    const { data } = await this.http({
      url: `${this.url}/export_csv`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })

    return data
  }

  static async getAppLogo () {
    const { data } = await this.http({
      url: `${this.url}/app_logo`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })

    return data
  }
}
